/**
 * 接口地址
 */

export const AUTH = process.env.MED_AUTH_HOST;
export const WEB = process.env.MED_AUTH_HOST;
export const INQUIRY_H5 = process.env.MED_INQUIRY_H5_HOST;
export const INQUIRY_WEB = process.env.MED_INQUIRY_WEB_HOST;
export const INTERLOCUTION_PAY = process.env.MED_INTERLOCUTION_PAY_HOST;
export const WEB_MED = process.env.MED_MG_HOST;
export const D2D = process.env.MED_D2D_API_HOST;
export const D2D_PH = process.env.MED_D2DPH_API_HOST;
export const PATIENT = process.env.MED_PATIENT_API_HOST;
export const WECHAT = process.env.MED_WECHAT_API_HOST;
export const PASSPORT = process.env.MED_PASSPORT_API_HOST;
export const APP = process.env.MED_APP_HOST;
export const IM_GATE = process.env.MED_IM_GATE_HOST;
export const IM_API = process.env.MED_IM_API_HOST;
export const MEDGPT = process.env.MED_VITE_HOST_MEDGPT;

export const BASE_SERVICE = process.env.MED_BASE_SERVICE;
export const PHOENIX = process.env.MED_HOST_PHOENIX;
export const GENERAL = process.env.MED_GENERAL;
export const PANEL = process.env.MED_PANEL_HOST;
export const DOCTOR_WORK_SSR = process.env.MED_SSR_DOCTOR_WORK_DOMAIN;
/**
 * cdm域名
 */
export const CDM_PATIENT_TOOLS = process.env.MED_CDM_PATIENT_TOOLS;
/**
 * ab服务域名
 */
export const AB_SERVICE = process.env.MED_AB_HOST;
/**
 * 滑块
 */
export const MED_CAPTCHA = process.env.MED_CAPTCHA_API_HOST;
export const API = process.env.MED_API_HOST;

export const MALL = process.env.MED_MALL_HOST;
export const SENSORS = process.env.MED_SENSORS_HOST;
// o2o域名
export const O2O = process.env.MED_APP_HOST_O2O;
